import { BaseDto } from './base.dto';
import { CustomerDto } from './customer.dto';
import { PosDeviceDto } from './posDevice.dto';
export class CartOrderNoteOptionDto extends BaseDto {
  text: string;
  enabled: boolean;
  cartId: number;
  selected: boolean;
  isPrinted?: boolean;
  customer?: CustomerDto;
  posDevice?: PosDeviceDto;
  posDeviceId?: number;
  clickedSequence?: number;
}
